import { ENTER_DELETE_TO_CONFIRM, REVOKE } from "../../constants/strings";
import { uppercase } from "../../utils/normalize";

export const revokeSharedSecretValidator = (values) => {
  const errors = {};

  if (
    !values.deleteConfirmation ||
    uppercase(values.deleteConfirmation) !== uppercase(REVOKE)
  ) {
    errors.deleteConfirmation = ENTER_DELETE_TO_CONFIRM;
  }

  return errors;
};

export const validateAccountNumber = (accountNum) =>
  accountNum.length >= 6 && accountNum.length <= 7;
